import { EtaDistanceResult, EtaLocation } from '@/feature/eta'

import { Loader } from '@/lib/core/components/Loader'

import { LocationToContent } from '../LocationToContent'
import { LocationToError } from '../LocationToError'
import styles from '../Eta.module.css'

export const CustomLocationTo = ({
  etaLocation,
  etaResult,
  error,
}: {
  etaLocation: EtaLocation
  etaResult?: EtaDistanceResult
  error?: string
}) => (
  <div className={styles.locationTo}>
    <div className={styles.locationToHeader}>
      <div>{etaLocation.address}</div>
    </div>
    {error ? (
      <LocationToError error={error} />
    ) : etaResult ? (
      <LocationToContent etaResult={etaResult} />
    ) : (
      <div className={styles.locationToLoading}>
        <Loader style={{ padding: '1.25rem' }} />
      </div>
    )}
  </div>
)
